const attachmenturl ="/var/www/crm.odisoft.in/crm_files";
export default attachmenturl;